<div #messageModal class="modal fade" tabindex="-1" role="dialog" aria-labelledby="message-modal-title"
     aria-hidden="true" [attr.data-backdrop]="protected">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="message-modal-title">{{ options?.title }}</h5>
                @if (options?.hideTimesButton !== true) {
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                }
            </div>
            <div class="modal-body">
                <p id="message-modal-text" [innerHTML]="options?.text"></p>
                <p id="message-modal-detail-text" [innerHTML]="options?.detailText"></p>
            </div>
            <div class="modal-footer">
                @if (options?.mode === undefined || options?.mode === messageModalMode.CLOSE) {
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
                }
                @if (options?.mode === messageModalMode.CONTINUE_CANCEL) {
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" (click)="doContinueAction()">Continue</button>
                }
                @if (options?.mode === messageModalMode.CONTINUE) {
                    <button type="button" class="btn btn-primary" (click)="doContinueAction()">Continue</button>
                }
                @if (options?.mode === messageModalMode.YES_NO_CANCEL) {
                    <button type="button" class="btn btn-secondary float-left" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" (click)="doNoAction()">No</button>
                    <button type="button" class="btn btn-primary" (click)="doYesAction()">Yes</button>
                }
                @if (options?.mode === messageModalMode.YES_NO) {
                    <button type="button" class="btn btn-primary" (click)="doNoAction()">No</button>
                    <button type="button" class="btn btn-primary" (click)="doYesAction()">Yes</button>
                }
                @if (options?.mode === messageModalMode.ACCEPT) {
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Accept</button>
                }
            </div>
        </div>
    </div>
</div>
